import React from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IOfflineExhibitorListItem } from "../type/offlineExhibitorType";
import OfflineExhibitorTableRow from "./OfflineExhibitorTableRow";

interface Props {
	isLoading: boolean;
	data: IOfflineExhibitorListItem[];
	paginationSkip: number | string;
	onView: (id: number) => void;
	onEdit: (id: number) => void;
	onDelete: (id: number, name: string) => void;
}

const OfflineExhibitorTable: React.FC<Props> = ({
	isLoading,
	data,
	paginationSkip,
	onView,
	onEdit,
	onDelete,
}) => {
	return (
		<TableContainer>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell sx={{ fontWeight: "bold" }}>SL.</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Exhibitor No</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Company Name</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Brochure</TableCell>
						<TableCell sx={{ fontWeight: "bold" }}>Creation Date</TableCell>
						<TableCell sx={{ fontWeight: "bold" }} align="right">
							Action
						</TableCell>
					</TableRow>
				</TableHead>

				{isLoading ? (
					<TableLoader />
				) : data && data.length > 0 ? (
					<TableBody>
						{data.map((exhibitor, index) => (
							<OfflineExhibitorTableRow
								key={exhibitor.id}
								exhibitor={exhibitor}
								index={index}
								paginationSkip={paginationSkip}
								onView={onView}
								onEdit={onEdit}
								onDelete={onDelete}
							/>
						))}
					</TableBody>
				) : (
					<TableNotFound />
				)}
			</Table>
		</TableContainer>
	);
};

export default OfflineExhibitorTable;
